import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSelect } from '@angular/material';
import { ICompany } from 'src/app/interfaces/company';
import { CIDService } from 'src/app/services/common/cid.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { DiscountGroupService } from 'src/app/services/http/business/discount-group/discount-group.service';

@Component({
  selector: 'app-discount-group-person-search',
  templateUrl: './discount-group-person-search.component.html',
  styleUrls: ['./discount-group-person-search.component.css']
})
export class DiscountGroupPersonSearchComponent implements OnInit {

  form: FormGroup;
  companyList: ICompany[];
  discountsType=[];
  dGPersonList:any;

  constructor(private fb: FormBuilder,
    private cidService: CIDService,
    private companyService: CompanyService,
    private dialog: MatDialogRef<DiscountGroupPersonSearchComponent>,
    private discountGroupService: DiscountGroupService
    ) { }

  ngOnInit() {

    this.createForm();
    this.getCompanyList();
    this.getDiscountsType(false);
  }
  createForm() {
    this.form = this.fb.group({
      CompanyEncryptId: [null, Validators.compose([Validators.required])],
      StudentFullName: [null],
      NationalCode: [null],
      DiscountGroupId: [null]
    });
  }

  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getDiscountsType(status):any{
    this.discountGroupService.discountByTypeList(status).subscribe(res => {
      this.discountsType = res;
    });
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
  }

  submit(data: any) {

    this.dialog.close(data);
  }

  onNoClick() {
    this.dialog.close();
  }

}
